import { Diagnosis } from "@/src/models/documents/referral";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export interface ProviderForDiagnosis {
  name: string;
  ehrId: string;
  isPreferred?: boolean;
}

export async function getProvidersForDiagnosis(
  diagnosisList: Diagnosis[],
  departmentId?: string
): Promise<ProviderForDiagnosis[]> {
  return fetchJSON<ProviderForDiagnosis[]>("/api/diagnosis-providers", {
    method: "POST",
    body: JSON.stringify({ diagnosisList, departmentId }),
  });
}
